import type { TFunction } from "i18next";
import { ContributingEntityRole } from "../../../../../autogen/bff-api";

const ROLE_BY_TYPE_CODE: Record<string, ContributingEntityRole> = {
  "CRITERION.OTHER.EO_DATA.TOGETHER_WITH_OTHERS": ContributingEntityRole.ConsortiumMember,
  "CRITERION.OTHER.EO_DATA.RELIES_ON_OTHER_CAPACITIES": ContributingEntityRole.CapacityProvider,
  "CRITERION.OTHER.EO_DATA.SUBCONTRACTS_WITH_THIRD_PARTIES": ContributingEntityRole.Subcontractor,
};

export const contributingRoleForTypeCode = (typeCode: string): ContributingEntityRole | undefined =>
  ROLE_BY_TYPE_CODE[typeCode];

export const groupRoleLabel = (role: ContributingEntityRole, t: TFunction): string =>
  role === ContributingEntityRole.ConsortiumMember ? t("Role in the group") : t("Part of the delivery");
